import { RouteFactory } from "@app/routePaths";
import AseanBanner from "@pages/Section/layouts/Verticals/AseanBusiness/components/AseanBanner";
import GlobalEnterpriseBanner from "@pages/Section/layouts/Verticals/GlobalEnterprise/components/GlobalEnterpriseBanner";
import SMEBanner from "@pages/Section/layouts/Verticals/SME/components/SMEBanner";

type VerticalsBannerProps = {
  /** The relative url path of the latest page */
  relativePath: string;
  /** Optional additional styling to the component */
  className?: string;
};

/**
 * Banner component for vertical latest pages, rendering the appropriate banner based on the relative path.
 * No Figma
 */
const VerticalsBanner = ({
  relativePath,
  className,
}: VerticalsBannerProps): React.ReactElement => {
  if (relativePath === RouteFactory.aseanBusinessLatest) {
    return <AseanBanner className={className} />;
  }

  if (relativePath === RouteFactory.globalEnterpriseLatest) {
    return <GlobalEnterpriseBanner className={className} />;
  }

  if (relativePath === RouteFactory.sgsmeLatest) {
    return <SMEBanner className={className} />;
  }

  return <></>;
};

export default VerticalsBanner;
